import { render, staticRenderFns } from "./ChangguanZhanhuiInfoBlock.vue?vue&type=template&id=58878057&scoped=true"
import script from "./ChangguanZhanhuiInfoBlock.vue?vue&type=script&lang=js"
export * from "./ChangguanZhanhuiInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58878057",
  null
  
)

export default component.exports